import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

import { scaleLinear } from 'd3-scale';



export function plot(config, context, projection, path, data) {
  // countries
  context.lineWidth = config.countryLineWidth;
  context.strokeStyle = 'rgba(229,229,229, 1)';

  data.countries.forEach(x => {
    context.beginPath();
    path(x);
    context.closePath();
    context.stroke();
  })

  // villages
  let radius = 0;

  let scaleVillageRadius = scaleLinear()
    .domain([0, 2000])
    .range([config.highlightRadiusMin, config.highlightRadiusMax])

  data.villages.forEach(x => {
      // get location
      const loc = projection([x.lon, x.lat]);
      context.arc(loc[0], loc[1], radius, 0, 2 * Math.PI);
      
      // draw icon
      context.lineWidth = config.villageRadius / 2;
      context.fillStyle = 'rgba(0, 0, 0, 0)';
      context.strokeStyle = 'rgba(22, 19, 69, 1)';
      radius = config.villageRadius;
      context.beginPath();
      context.arc(loc[0], loc[1], radius, 0, 2 * Math.PI);
      context.closePath();
      context.stroke();
      
      // draw bubble
      context.lineWidth = 0;
      context.fillStyle = 'rgba(22, 19, 69, .3)'
      const highlightRadius = scaleVillageRadius(x.num_trips);
      const pct = config.highlightRadiusPct;
      radius = highlightRadius * pct;
      context.beginPath();
      context.arc(loc[0], loc[1], radius, 0, 2 * Math.PI);
      context.closePath();
      context.fill();
  })


  // bridges
  context.strokeStyle = 'rgba(0,145,73,1)';
  
  data.bridges.forEach(x => {
    context.beginPath();
    const loc = projection([x.bridge_lon, x.bridge_lat]);
    const radius = config.bridgeRadius;

    context.lineWidth = radius/2;
    context.arc(loc[0], loc[1], radius, 0, 2 * Math.PI);
    context.closePath();
    context.stroke();
  })


  // trips
  data.trips.forEach(x => {
    context.fillStyle = x.fillColor === undefined ? 'rgba(22, 19, 69, .1)' : x.fillColor;
    context.beginPath();
    const loc = projection([x.current_lon, x.current_lat]);
    const radius = config.tripRadius;
    context.arc(loc[0], loc[1], radius, 0, 2 * Math.PI);
    context.closePath();
    context.fill();
  })
}
